import './App.css';
import {MsalProvider} from '@azure/msal-react';
import {BrowserRouter, Navigate, Route, Routes, useLocation, useSearchParams} from "react-router-dom";
import {GlobalNavBar} from "./components/GlobalNavBar";
import {HomeComponent} from "./components/home/HomeComponent";
import {RealTimeInsightsComponent} from "./components/insights/page/RealTimeInsightsComponent";
import {ThorComponent} from "./components/thor/page/ThorComponent";
import {ThorAudiencesPage} from "./components/thor/page/ThorAudiencesPage";
import {ThorExclusionGroupsPage} from "./components/thor/page/ThorExclusionGroupsPage";
import {ThorResurrectorPage} from "./components/thor/page/ThorResurrectorPage";
import {ThorHammerPage} from "./components/thor/page/ThorHammerPage";

// Preserves ?experiment=... and any other query params when redirecting
const Redirect = ({ to }) => {
    const [searchParams] = useSearchParams();
    const qs = searchParams.toString();
    return <Navigate to={qs ? `${to}?${qs}` : to} replace />;
};

// Hard redirect — causes a full page reload so authConfig re-evaluates window.location.pathname.
// Needed for /thor → /thor/experiments: without it, MSAL initialises with redirectUri='/thor'
// (no MsalProvider at that path) and the auth code response is never handled.
const HardRedirect = ({ to }) => {
    const [searchParams] = useSearchParams();
    const qs = searchParams.toString();
    window.location.replace(qs ? `${to}?${qs}` : to);
    return null;
};

// Hammer is embedded standalone (iframe from the legacy TripResearch servlet) and
// isn't a normal navigable destination, so it never shows the shared site nav.
const ConditionalNavBar = () => {
    const location = useLocation();
    if (location.pathname === '/thor/hammer') return null;
    return <GlobalNavBar/>;
};

const App = ({instance}) => {
    return (
        <BrowserRouter>
            <ConditionalNavBar/>
            <Routes>
                <Route exact={true} path="/" element={
                    <MsalProvider instance={instance}>
                        <HomeComponent/>
                    </MsalProvider>
                }></Route>

                <Route exact={true} path="/real-time-insights" element={
                    <MsalProvider instance={instance}>
                        <RealTimeInsightsComponent>
                        </RealTimeInsightsComponent>
                    </MsalProvider>
                }></Route>

                {/* Legacy paths redirect to new nested structure */}
                <Route path="/thor" element={<HardRedirect to="/thor/experiments" />} />
                <Route path="/thor-hammer" element={<Redirect to="/thor/hammer" />} />

                <Route path="/thor/hammer" element={
                    <MsalProvider instance={instance}>
                        <ThorHammerPage />
                    </MsalProvider>
                }></Route>

                <Route path="/thor/experiments" element={
                    <MsalProvider instance={instance}>
                        <ThorComponent/>
                    </MsalProvider>
                }></Route>

                <Route path="/thor/audiences" element={
                    <MsalProvider instance={instance}>
                        <ThorAudiencesPage/>
                    </MsalProvider>
                }></Route>

                <Route path="/thor/exclusion-groups" element={
                    <MsalProvider instance={instance}>
                        <ThorExclusionGroupsPage/>
                    </MsalProvider>
                }></Route>

                <Route path="/thor/resurrector" element={
                    <MsalProvider instance={instance}>
                        <ThorResurrectorPage/>
                    </MsalProvider>
                }></Route>
            </Routes>
        </BrowserRouter>
    );
};

export default App;
